import { createSelector } from 'reselect';
import precise from '../../src/modules/precise';

const driverIdFeeSel = state => state.otherTransactionFees.driversLicenseIdFee;
const propertyTaxSel = state => state.otherTransactionFees.propertyTaxFee;
const huntingFishingSel = state => state.otherTransactionFees.huntingAndFishingFee;

const selector = createSelector(
  [driverIdFeeSel, propertyTaxSel, huntingFishingSel],
  (_driversLicenseIdFee, _propertyTaxFee, _huntingFishingFee) => {
    const driversLicenseIdFee = Number(_driversLicenseIdFee);
    const propertyTaxFee = Number(_propertyTaxFee);
    const huntingFishingFee = Number(_huntingFishingFee);

    return precise(driversLicenseIdFee + propertyTaxFee + huntingFishingFee);
  },
);

export default selector;
